<div class="header">

  <button class="btn btn-rounded btn-light" (click)="handleGoBack()">
    <img src="assets/icons/back.svg" alt="">
  </button>

  <div class="title">
    {{addOn()?.bannerTitle}}
  </div>

  <div class="right-side">

    @if(pdfs().length > 0){
    <div class="dropdown" appDropdown>

      <button class="btn btn-rounded btn-light dropdown-toggle" data-bs-toggle="dropdown">
        <img src="assets/icons/ellipsis.svg" alt="">
      </button>

      <ul class="dropdown-menu">

        @for(pdf of pdfs(); track $index){
        <li>
          <button class="dropdown-item" (click)="sharedService.navigateTo_PdfPage(pdf)">
            {{"Download PDF"|translate}}
            <img src="assets/icons/pdf.svg" alt="file">
          </button>
        </li>
        }

      </ul>

    </div>
    }

  </div>

</div>

<div class="pdp-page container-fluid">

  <div class="row">

    <div class="col col-6">
      @if (video()) {
      <app-video [video]="video()"></app-video>
      }
    </div>

    <div class="col col-6">
      <h2>{{title()}}</h2>
      <p>{{addOn()?.bannerText}}</p>
    </div>

  </div>
